module.exports = __webpack_public_path__ + "static/img/1-2.22b2a98.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/1-2.png
// module id = vRvF
// module chunks = 0